import useInterval from './useInterval'
export default useInterval
